import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const AlertHexagonIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <g clipPath="url(#alert_hexagon_svg__a)">
      <path
        fillRule="evenodd"
        d="M8.727 11.641a.726.726 0 1 0-1.453 0 .726.726 0 0 0 1.452 0m0-7.274a.726.726 0 1 0-1.454 0v4.368a.726.726 0 1 0 1.454 0zM5.422 1.63a.75.75 0 0 1 .474-.177h4.207q.267 0 .473.177l3.717 3.185a.72.72 0 0 1 .253.55v5.262a.72.72 0 0 1-.253.55l-3.717 3.184a.75.75 0 0 1-.473.178H5.897a.7.7 0 0 1-.474-.178l-3.717-3.185a.72.72 0 0 1-.253-.549V5.364a.72.72 0 0 1 .253-.549L5.423 1.64zM5.897 0c-.524 0-1.023.186-1.42.524L.76 3.717A2.2 2.2 0 0 0 0 5.373v5.263c0 .633.279 1.242.76 1.655l3.717 3.185c.397.338.896.524 1.42.524h4.207c.523 0 1.022-.186 1.419-.524l3.717-3.185a2.2 2.2 0 0 0 .76-1.655V5.373a2.2 2.2 0 0 0-.76-1.656L11.523.532a2.18 2.18 0 0 0-1.42-.524H5.898z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="alert_hexagon_svg__a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
AlertHexagonIcon.id = 'AlertHexagonIcon';
AlertHexagonIcon.displayName = 'AlertHexagonIcon';
export default AlertHexagonIcon;
